export { default as ArrowUTurnLeftSolidIcon } from './ArrowUTurnLeftSolidIcon';
